module.exports = __webpack_public_path__ + "media/bowls/illustrated-bowl-1614a11c.svg";